import { IRequestType } from '@interfaces/request';
import { log } from './logger';

interface ITrackingEntry {
    event: string;
    [key: string]: unknown;
}
export interface IWindow extends Window {
    dataLayer?: ITrackingEntry[];
    ga: any;
}

declare let window: IWindow;

/**
 * @TODO Cleanup this, maybe use custom hook
 */
export class EventTracker {
    private getTrackerName = () =>
        typeof window !== 'undefined' && window.ga ? window.ga.getAll()[0].get('name') : null;

    /**
     * Click is the default event type
     */
    public track = async (props: ITrackingEntry) => {
        if (!props?.action) {
            log.warn(`Called track function without property "action"`);
            return;
        }
        if (!props?.category) {
            log.warn(`Called track function without property "category"`);
            return;
        }
        if (!props?.label) {
            log.warn(`Called track function without property "label"`);
            return;
        }
        const { event, action, category, label } = props;
        try {
            const trackerName = this.getTrackerName();

            if (!(window.dataLayer && window.dataLayer.push)) {
                window.dataLayer = [];
            }
            if (event !== 'page-open') {
                window.dataLayer.push({
                    event,
                    category,
                    action,
                    label,
                });

                if (trackerName) {
                    window.ga(`${trackerName}.send`, event, category, action, label);
                }
            }
        } catch (err) {
            log.error('GA ecommerce tracking', err);
            return;
        }
    };

    public ga4Track(eventName: string, extraData?: Record<string, unknown>) {
        if (!window) {
            return;
        }

        if (!(window.dataLayer && window.dataLayer.push)) {
            window.dataLayer = [];
        }

        window.dataLayer.push({
            event: eventName,
            ...extraData,
        });
    }
}

export const eventTracker = new EventTracker();

export const sendPageLoadEvent = () => {
    eventTracker.track({
        event: 'page-open',
        category: 'view',
        action: 'view',
        label: 'Page Loaded',
    });
};

const landingPageCategories: { [key in IRequestType]: string } = {
    ship: 'ship-page',
    cruiseline: 'cruise-line-page',
    destination: 'destination-page',
    ugc: 'ugc-subpage',
};
// @TODO: we need another way to manage interfaces here
const landingPageActions: { [key in IRequestType | 'stickyBar']: string } = {
    ship: 'ship-position-module',
    cruiseline: 'ship-module',
    destination: 'harbour-module',
    ugc: 'review-module',
    stickyBar: 'sticky-bar',
};

export const getLandingPageCategory = (type: IRequestType) => landingPageCategories[type];
export const getLandingPageActions = (type: IRequestType | 'stickyBar') => landingPageActions[type];
